"use client"

import "../styles/Highlights.css"
import highlightbg from "../assets/images/highlights-bg.webp"

export default function Highlights({ onOpenModal }) {
  const highlights = [
    "Design & Architecture By: Studio Symbiosis",
    "Central park: 3 Acres",
    "Biggest club house: 70,000 Sq Ft",
    "5 High Speed Lifts",
    "VRV air-conditioning",
    "12ft ceiling height"
  ]

  return (
    <section id="highlights" className="highlights">
      <div className="highlights-container">
        <div className="highlights-left">
          <h3 className="section-label">HIGHLIGHTS</h3>
          <h2 className="section-title">Ashtech Presidential Towers</h2>
          <p className="description">Advanced security systems and 24/7 surveillance.</p>
          <button className="inter1" onClick={onOpenModal}>
            INTERESTED
          </button>
        </div>

        <div className="highlights-right">
          {highlights.map((highlight, index) => (
            <div key={index} className="highlight-item">
              <span className="checkmark">✓</span>
              <span className="highlightspan">{highlight}</span>
            </div>
          ))}
        </div>


        <style>{`
.highlights {
  position: relative;
  padding: 80px 20px;
  background-color: var(--light-color);
  max-width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
}

.highlights::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${highlightbg});
  background-size: cover;
  background-position: center;
  opacity: 0.1; 
  z-index: -1;
}
      `}</style>
      </div>
    </section>
  )
}
